/**-- external -- */
import { createContext } from "react";

const STABLE_INITIAL_CONTEXT = {};

export const ControlParameterContext = createContext(STABLE_INITIAL_CONTEXT);
